import { useState, useEffect, useRef, useContext } from 'react';
import { logOut } from './index';
import UserContext from '../../../Context/user/userProvider';

function useHeaderSession() {
  const { userDetail } = useContext(UserContext);
  const cardRef = useRef()
  const [isOpen, setIsOpen] = useState(false);
  const [isIssetSession, setIsIssetSession] = useState(false);

  const optionListWithSession = [
    {
      text: 'Mi Perfil',
      url: '/profile'
    },
    {
      text: 'Cerrar Sesión',
      action: closeSession
    },
  ]
  const optionListWithOutSession = [
    {
      text: 'Registrarme',
      url: '/register'
    },
    {
      text: 'Iniciar sesion',
      url: '/login'
    },
  ]

  const optionList = isIssetSession ? optionListWithSession : optionListWithOutSession;

  async function closeSession() {
    try {
      await logOut()
    } catch (error) {
      console.error('Error Logout from header:', error)
    }
  }

  useEffect(() => {
    setIsIssetSession(!!userDetail);
  }, [isOpen])

  useEffect(() => {
    function handleClickOutside(event) {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [])

  return {
    isOpen,
    setIsOpen,
    cardRef,
    optionList,
    userDetail,
  }
}

export default useHeaderSession;
